import React from 'react';
import './Blogs.css';

const Blogs=()=> {
  return (
    <div className='blogs'>
      <h2>
        1. What is contaxt api?
      </h2>
      <h3>
        The Context API is a React structure that enables you to exchange unique details and assists in solving prop-drilling from all levels of your application. It is using for changing state. 
        Redux is the best example of an context api.
      </h3>

      <h2>
        2. What is symantic tag?
      </h2>
      <h3>
        Semantic HTML elements are those that clearly describe their meaning in a human- and machine-readable way.
        Now elements are header, footer, aside, artical ect.
      </h3>
    </div>
  )
}

export default Blogs;